const angular  = require('angular');

/**
 * Require Infinite Scroll
 */
require('ng-infinite-scroll/build/ng-infinite-scroll.js');
angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);

/**
 * Require imagesLoaded
 */
window.imagesLoaded = require('imagesloaded');
/**
 * Require masonry
 */
window.Masonry = require('masonry-layout');

require('../../../global/src/js/helper');

require('./vendor/modernizr');
require('./vendor/flip');
const ngModule = angular.module('cambuildr.module.grassroots', [
    'ngRoute',
    'ngAnimate',
    'ct.services.api',
    'ct.services.hash',
    'ct.directives.labelHide',
    'ct.directives.shareWindow',
    'ct.directives.masonry',

          require('../../../global/src/js/modules/directive/state-class'),
          require('../../../global/src/js/directive/mediaDrop.js'),
          require('../../../global/src/js/services/ChannelRepository'),
          require('../../../global/src/js/modules/directive/share-form'),
          require('../../../global/src/js/services/EventTracker.js'),
          require('../../../global/src/js/services/PrefillService'),
          require('../../../global/src/js/directive/stateButton.js'),
          require('../../../global/src/js/filter/links'),
    require('../../../global/src/js/directive/selecty'),

    // require('./directives/flipToggle')
          // require('cb-directives-parallaxbackgroundmoover'),
      ]);


ngModule
    .constant('AppConstants', require('../../../global/src/js/constants/module.json'))
    .animation('.jsAnimationSlideIn', require('../../../global/src/js/animations/_slideIn.js'))

    .value('POPUP_HASH_KEY', 'commitment')
;

ngModule
    .config(require('./config/routes'))
;
ngModule
    .run(["CTHashService", "CTHash", (CTHashService) => CTHashService.useSearch(true)])
    .run(require('../../../global/src/js/modules/run/PopupSupervisor.js'))
;

/**
 * Fixes a bug where angular does not load the initial route
 * (http://stackoverflow.com/a/20664709/2753395)
 */
ngModule.run(['$route', function($route)  {
    $route.reload();
}]);

ngModule
    .service('DataService', require('./services/GrassrootsDetailDataService'))
    .service('CurrentCampaign', require('./services/_CurrentCampaign'))
;

ngModule
    .factory('CommitmentModel', require('../../../commitment/src/js/factory/CommitmentModel.js'))
;


ngModule
    .controller('PageViewController', require('./controller/_PageViewController.js'))
    .controller('CampaignController', require('./controller/_CampaignController.js'))
    .controller('CampaignEditController', require('./controller/_CampaignEditController.js'))
    .controller('ActionbarController', require('../../../global/src/js/modules/controller/ActionbarController.js'))
    .controller('GrassrootsCampaignCreateController', require('./controller/_GrassrootsCampaignCreateController.js'))

    .controller('SignupController', require('./controller/SignupController.js'))
    .controller('MultistepSignupController', require('./controller/MultistepSignupController.js'))
    .controller('MultistepPopupController', require('../../../commitment/src/js/controller/MultistepPopupController.js'))

    .controller('SocialMediaSignupController', require('../../../global/src/js/modules/controller/SocialMediaSignupController.js'))
    .controller('UseFacebookUserImageController', require('../../../global/src/js/modules/controller/UseFacebookUserImageController.js'))
    .controller('TagListingController', require('../../../global/src/js/modules/controller/TagListingController.js'))

    .controller('WallController', require('./controller/WallController.js'))
    .controller('CommitmentController', require('./controller/CommitmentController.js'))
    .controller('PopupController', require('../../../global/src/js/modules/controller/PopupController.js'))
    .controller('ActionsController', require('../../../global/src/js/modules/controller/ActionsController.js'))
    .controller('WallStampController', require('../../../global/src/js/modules/controller/WallStampController.js'))
    .controller('CounterController', require('./controller/CounterController.js'))


;


// Trigger Animations on Load
document.body.classList.add('js-loading');

window.addEventListener("load", showPage);

function showPage() {
    document.body.classList.remove('js-loading');
}
